module.exports = "i.rating {\n  color: #FBBD08; }\n"